export const requestDemoEmail = () => {
    const to = "usconsultingfuturescapeasset@deloitte.com";
    const subject = encodeURIComponent("[FUTURESCAPE] Request Demo");
    window.location.href = `mailto:${to}?subject=${subject}`;
};